import { render, staticRenderFns } from "./hiresource.vue?vue&type=template&id=21ed4746&"
import script from "./hiresource.vue?vue&type=script&lang=ts&"
export * from "./hiresource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports